import React from "react";
import "./selectsequence.css";
import { LineNumberRestartFormat } from "docx";
import FilePlayer from "react-player/file";

class SelectSequence extends React.Component {
  constructor(props) {
    super(props);

    var found = -1;
    this.props.list.forEach((element,index) => {
        if ( (found === -1) &&  (element.astype === this.props.type)) found = index;
    });

    if (found === -1) found = 0;

    this.state = {
      selectedIndex: props.defaultIndex || found
    };
  }

  handleSelect = (item, index) => {
    this.setState({
      selectedIndex: index
    });

    if (this.props.onClick) {
      this.props.onClick(item, index);
    }
  };

  render() {
    const { list } = this.props;
    const { selectedIndex } = this.state;

    var found = false;
    list.forEach(element => {
        if (element.astype === this.props.type) found = true;
    });

    if (!found ) return (<></>)


    return (
      <div className="select-sequence-container">
        {list.map((item, index) => { 
          var smalltitle = "SEQUENCES";
          if (this.props.type === 9) smalltitle="Document "+item.asext;
          if (item.astype === this.props.type)
          {
            return (
            <div
              key={`${item.asid}-${item.astype}-${index}`}
              className={`sequence-item ${
                selectedIndex == index ? "active" : ""
              }`}
              onClick={() => this.handleSelect(item, index)}
            >
              <div className="sequence-title">
                {item.astitle}
              </div>

              <div className="sequence-meta">
                <span>Asset&nbsp;{item.asid}&nbsp; ({smalltitle})</span>
              </div>
            </div>
          )}
        }
        )}
      </div>
    );
  }
}

SelectSequence.defaultProps = 
{
  type: 8,
  list: [],
}
export default SelectSequence;